/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StrikethroughIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVR4nNVVPUskQRCd9QMxMDiMRJCLRBDkzhUUAzcRbmGnPsajp2r2OEWQDUQM1WwNTRWMNNVINhB/gL9BBEMTN7gDAzk4BZU7GvZj1HXtXfcOfVDJdM971a+6qj3vLQARe4CFMNBlIF0B1jlE/fxq4iD41oesu0hyjax/HgewnACL3xQ5kXxE1osnpCT3Nb5tep6XaEgASY5jmRaIZNIY022JMhnTDyxLQPIjJrLuTA6gI1Vy3Xtun++bAWA9LwkcOQsQiVQsCMTU2+vPREPIms/lcp3OAojhbFnAp+ir12pYi4D0V8n/Q+9dgDmbRAynWxHM2eQTASC9q9VM2ERYrv8vwA1Y5FO0iCRnD4nloLIehKOtKFsCMZwvjw4gvSx1emuBJPvlUxBlPzn/aIxpdxJgWasKhF/cssJwCkl/2o52ENiu1AF17EVy5u+9yHpT8vU3BJquP9LlqlyDVCrV4XYC1o3YDbkFlh0IwolMJvshnU53McsgUbQALMXYuF71XJHP59uQZcv53rMUXGv2AD5FjCyndYiL9p22CTVMHgeADtuH3tpgw9qDqOPOnv9L/AWJWmR11p5knQAAAABJRU5ErkJggg==)
 */
export const StrikethroughIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.1 22.5c-1.8 0-3.3-.37-4.53-1.11A7.95 7.95 0 0 1 4.9 18.8a.46.46 0 0 1 .1-.6l1.38-1.16a.5.5 0 0 1 .73.12 7.44 7.44 0 0 0 1.92 2.04 5.8 5.8 0 0 0 3.22.81c1.36 0 2.42-.3 3.16-.9a3.13 3.13 0 0 0 1.14-2.6c0-1.02-.42-1.79-1.26-2.32a9.65 9.65 0 0 0-2.15-.94H2.5a.5.5 0 0 1-.5-.5v-1.5c0-.28.22-.5.5-.5h19c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5h-3.16l.1.15c.57.76.86 1.75.86 2.96a5.6 5.6 0 0 1-1.93 4.5c-1.29 1.1-3.04 1.64-5.27 1.64ZM5.7 8.36c.09.39.45.64.85.64h2.1c.18 0 .28-.25.15-.4a2.46 2.46 0 0 1-.56-1.66c0-.96.36-1.69 1.08-2.2a4.94 4.94 0 0 1 2.93-.78c1.11 0 2.03.22 2.75.67.62.38 1.24 1 1.86 1.82.17.23.49.28.7.1l1.22-1.02a.46.46 0 0 0 .1-.6 7.76 7.76 0 0 0-6.63-3.43c-1.23 0-2.35.22-3.36.67a5.03 5.03 0 0 0-3.3 4.86c-.01.47.03.92.12 1.33Z"
        className={colorClass}
      />
    </svg>
  );
};
